import React from 'react';
import { mergeClasses } from '@griffel/react';

const UIPicture = ({ className, src, alt, hasProtection = true }) =>
{
	const baseClass = 'protected';
	const preventContextMenu = (e) => e.preventDefault();

	return (
		<picture className={mergeClasses(baseClass, className)}>
			{hasProtection && (
				<img
					src={`${process.env.PUBLIC_URL}/img/img_protect.png`}
					onContextMenu={preventContextMenu}
					className={'protect'}
				/>
			)}
			<img
				src={src}
				alt={alt}
				onContextMenu={preventContextMenu}
			/>
		</picture>
	);
};

export default UIPicture;